export default __webpack_public_path__ + "static/media/iPhone-Premium-6.e67f96f7.png";